/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaEnd
// ====================================================

export interface TrackMediaEnd_trackMediaEnd {
  __typename: 'AudioContent' | 'VideoContent'
}

export interface TrackMediaEnd {
  /**
   * Track end event on media content by current user
   */
  trackMediaEnd: TrackMediaEnd_trackMediaEnd
}

export interface TrackMediaEndVariables {
  data: any
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaPause
// ====================================================

export interface TrackMediaPause_trackMediaPause {
  __typename: 'AudioContent' | 'VideoContent'
}

export interface TrackMediaPause {
  /**
   * Track pause event on media content by current user
   */
  trackMediaPause: TrackMediaPause_trackMediaPause
}

export interface TrackMediaPauseVariables {
  data: any
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaPlay
// ====================================================

export interface TrackMediaPlay_trackMediaPlay {
  __typename: 'AudioContent' | 'VideoContent'
}

export interface TrackMediaPlay {
  /**
   * Track play event on media content by current user
   */
  trackMediaPlay: TrackMediaPlay_trackMediaPlay
}

export interface TrackMediaPlayVariables {
  data: any
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaSeek
// ====================================================

export interface TrackMediaSeek_trackMediaSeek {
  __typename: 'AudioContent' | 'VideoContent'
}

export interface TrackMediaSeek {
  /**
   * Track seek event on media content by current user
   */
  trackMediaSeek: TrackMediaSeek_trackMediaSeek
}

export interface TrackMediaSeekVariables {
  data: any
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaVolumeChange
// ====================================================

export interface TrackMediaVolumeChange_trackMediaVolumeChange {
  __typename: 'AudioContent' | 'VideoContent'
}

export interface TrackMediaVolumeChange {
  /**
   * Track volume change on media content by current user
   */
  trackMediaVolumeChange: TrackMediaVolumeChange_trackMediaVolumeChange
}

export interface TrackMediaVolumeChangeVariables {
  data: any
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeCollectionDisplayStatus
// ====================================================

export interface ChangeCollectionDisplayStatus_changeCollectionDisplayStatus {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
}

export interface ChangeCollectionDisplayStatus {
  changeCollectionDisplayStatus: ChangeCollectionDisplayStatus_changeCollectionDisplayStatus
}

export interface ChangeCollectionDisplayStatusVariables {
  id: string
  status: CollectionDisplayStatus
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeContentDisplayStatus
// ====================================================

export interface ChangeContentDisplayStatus_changeContentDisplayStatus {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface ChangeContentDisplayStatus {
  changeContentDisplayStatus: ChangeContentDisplayStatus_changeContentDisplayStatus
}

export interface ChangeContentDisplayStatusVariables {
  id: string
  status: ContentDisplayStatus
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionForMetadata
// ====================================================

export interface CollectionForMetadata_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
  canManage: boolean
  canRead: boolean
  slug: string
  visibility: Visibility
  selling: boolean
  sellingMethod: string | null
  sellingPricing: number | null
  collectionDisplayStatus: CollectionDisplayStatus
  need_registration: boolean

  creator: {
    __typename: 'User'
    vanity_name: string | null
    subscriptionPlan: {
      id: string
      code: string
    }
    workspace: Workspace | null
  }
}

export interface CollectionForMetadata {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionForMetadata_collection | null
  /**
   * Currently authenticated user
   */
  me: CollectionPageContents_me | null
  /**
   * Workspace of the collection creator, if available
   */
   workspace: Workspace | null
}

export interface CollectionForMetadataVariables {
  identifier: string
  token?: string | null
  userId?: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentForRedirectAndMetadata
// ====================================================

export interface ContentForRedirectAndMetadata_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
  canManage: boolean
  canRead: boolean
  canDownload: boolean
  visibility: Visibility
  visibilityForCollection: Visibility
  slug: string
  displayStatus: ContentDisplayStatus
  creator: CardDetails_creator
  need_registration: boolean
  parentSavedCollectionId: string | null
}

export interface ContentForRedirectAndMetadata {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentForRedirectAndMetadata_content | null
}

export interface ContentForRedirectAndMetadataVariables {
  collectionIdentifier?: string
  identifier: string
  token?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAuthorizationTokenForCollection
// ====================================================

export interface GenerateAuthorizationTokenForCollection {
  token: string
}

export interface GenerateAuthorizationTokenForCollectionVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CardCollectionStatusAnalytics
// ====================================================

export interface CardCollectionStatusAnalytics_collection_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardCollectionStatusAnalytics_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  history: CardCollectionStatusAnalytics_collection_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the collection
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the collection
   */
  totalUserVisitors: number
  /**
   * Total visitors to the collection
   */
  totalVisitors: number
  /**
   * Total visits to the collection
   */
  totalVisits: number
}

export interface CardCollectionStatusAnalytics {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CardCollectionStatusAnalytics_collection | null
}

export interface CardCollectionStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserCollections
// ====================================================

export interface CurrentUserCollections_me_collections_edges_node {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Determines if a content is included in subject collection
   */
  includes: boolean
  /**
   * Main title
   */
  title: string
}

export interface CurrentUserCollections_me_collections_edges {
  __typename: 'CollectionEdge'
  /**
   * The Collection node.
   */
  node: CurrentUserCollections_me_collections_edges_node
}

export interface CurrentUserCollections_me_collections {
  __typename: 'CollectionConnection'
  /**
   * A list of Collection edges.
   */
  edges: CurrentUserCollections_me_collections_edges[]
}

export interface CurrentUserCollections_me {
  __typename: 'User'
  /**
   * Collections managed by the user
   */
  collections: CurrentUserCollections_me_collections | null
  id: string
}

export interface CurrentUserCollections {
  /**
   * Currently authenticated user
   */
  me: CurrentUserCollections_me | null
}

export interface CurrentUserCollectionsVariables {
  includes: string
  visibility?: Visibility[] | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleContentCollectionAssociation
// ====================================================

export interface ToggleContentCollectionAssociation {
  toggleContentCollectionAssociation: boolean
}

export interface ToggleContentCollectionAssociationVariables {
  associated: boolean
  collectionId: string
  contentId: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AddToCalendarData
// ====================================================

export interface AddToCalendarData_content_AudioContent {
  __typename:
    | 'AudioContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface AddToCalendarData_content_EventContent {
  __typename: 'EventContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main description, if given
   */
  description: string | null
  end: any | null
  location: string | null
  start: any | null
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
}

export type AddToCalendarData_content =
  | AddToCalendarData_content_AudioContent
  | AddToCalendarData_content_EventContent

export interface AddToCalendarData {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AddToCalendarData_content | null
}

export interface AddToCalendarDataVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConfirmCancelEvent
// ====================================================

export interface ConfirmCancelEvent_cancelEventContent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface ConfirmCancelEvent_cancelEventContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ConfirmCancelEvent_cancelEventContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ConfirmCancelEvent_cancelEventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: ConfirmCancelEvent_cancelEventContent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ConfirmCancelEvent_cancelEventContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ConfirmCancelEvent_cancelEventContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
}

export interface ConfirmCancelEvent {
  cancelEventContent: ConfirmCancelEvent_cancelEventContent
}

export interface ConfirmCancelEventVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RelatedContentsList
// ====================================================

export interface RelatedContentsList_content_relatedContents {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface RelatedContentsList_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  relatedContents: RelatedContentsList_content_relatedContents[]
}

export interface RelatedContentsList_user_contents_edges_node {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
}

export interface RelatedContentsList_user_contents_edges {
  __typename: 'ContentEdge'
  /**
   * The Content node.
   */
  node: RelatedContentsList_user_contents_edges_node
}

export interface RelatedContentsList_user_contents {
  __typename: 'ContentConnection'
  /**
   * A list of Content edges.
   */
  edges: RelatedContentsList_user_contents_edges[]
}

export interface RelatedContentsList_user {
  __typename: 'User'
  /**
   * Contents managed by the user
   */
  contents: RelatedContentsList_user_contents | null
  id: string
}

export interface RelatedContentsList {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: RelatedContentsList_content | null
  /**
   * Currently authenticated user
   */
  user: RelatedContentsList_user | null
}

export interface RelatedContentsListVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleRelatedContentAssociation
// ====================================================

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_EventContent {
  __typename: 'EventContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_AudioContent {
  __typename: 'AudioContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_ImageContent {
  __typename: 'ImageContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_LinkContent {
  __typename: 'LinkContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent {
  __typename: 'PdfContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * PDF document additional details
   */
  pdfDetails: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent_pdfDetails | null
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent {
  __typename: 'QuizContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  questions: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent_questions[]
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_TextContent {
  __typename: 'TextContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_VideoContent {
  __typename: 'VideoContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export type ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents =

    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_EventContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_AudioContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_ImageContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_LinkContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_TextContent
    | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_VideoContent

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  relatedContents: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents[]
}

export interface ToggleRelatedContentAssociation {
  toggleRelatedContentsAssociation: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation
}

export interface ToggleRelatedContentAssociationVariables {
  associated: boolean
  objectId: string
  subjectId: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAuthorizationTokenForContent
// ====================================================

export interface GenerateAuthorizationTokenForContent {
  token: string
}

export interface GenerateAuthorizationTokenForContentVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CardAudioContentStatusAnalytics
// ====================================================

export interface CardAudioContentStatusAnalytics_content_EventContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardAudioContentStatusAnalytics_content_EventContent {
  __typename:
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  history: CardAudioContentStatusAnalytics_content_EventContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
}

export interface CardAudioContentStatusAnalytics_content_AudioContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardAudioContentStatusAnalytics_content_AudioContent {
  __typename: 'AudioContent'
  history: CardAudioContentStatusAnalytics_content_AudioContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
  totalUsersCompleted: number
  totalUsersStarted: number
}

export type CardAudioContentStatusAnalytics_content =
  | CardAudioContentStatusAnalytics_content_EventContent
  | CardAudioContentStatusAnalytics_content_AudioContent

export interface CardAudioContentStatusAnalytics {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: CardAudioContentStatusAnalytics_content | null
}

export interface CardAudioContentStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CardContentStatusAnalytics
// ====================================================

export interface CardContentStatusAnalytics_content_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardContentStatusAnalytics_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  history: CardContentStatusAnalytics_content_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
}

export interface CardContentStatusAnalytics {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: CardContentStatusAnalytics_content | null
}

export interface CardContentStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CardQuizContentStatusAnalytics
// ====================================================

export interface CardQuizContentStatusAnalytics_content_AudioContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardQuizContentStatusAnalytics_content_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'TextContent'
    | 'VideoContent'
  history: CardQuizContentStatusAnalytics_content_AudioContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
}

export interface CardQuizContentStatusAnalytics_content_QuizContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardQuizContentStatusAnalytics_content_QuizContent {
  __typename: 'QuizContent'
  history: CardQuizContentStatusAnalytics_content_QuizContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
  totalUsersCompleted: number
  totalUsersStarted: number
}

export type CardQuizContentStatusAnalytics_content =
  | CardQuizContentStatusAnalytics_content_AudioContent
  | CardQuizContentStatusAnalytics_content_QuizContent

export interface CardQuizContentStatusAnalytics {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: CardQuizContentStatusAnalytics_content | null
}

export interface CardQuizContentStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CardVideoContentStatusAnalytics
// ====================================================

export interface CardVideoContentStatusAnalytics_content_AudioContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardVideoContentStatusAnalytics_content_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
  history: CardVideoContentStatusAnalytics_content_AudioContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
}

export interface CardVideoContentStatusAnalytics_content_VideoContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CardVideoContentStatusAnalytics_content_VideoContent {
  __typename: 'VideoContent'
  history: CardVideoContentStatusAnalytics_content_VideoContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
  totalUsersCompleted: number
  totalUsersStarted: number
}

export type CardVideoContentStatusAnalytics_content =
  | CardVideoContentStatusAnalytics_content_AudioContent
  | CardVideoContentStatusAnalytics_content_VideoContent

export interface CardVideoContentStatusAnalytics {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: CardVideoContentStatusAnalytics_content | null
}

export interface CardVideoContentStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveUserElement
// ====================================================

export interface RemoveUserElement {
  removeUserElement: boolean
}

export interface RemoveUserElementVariables {
  id: string
  type: RemoveUserElementType
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAuthorization
// ====================================================

export interface AddAuthorization_setAuthorization {
  __typename: 'Authorization'
  id: string
}

export interface AddAuthorization {
  setAuthorization: AddAuthorization_setAuthorization
}

export interface AddAuthorizationVariables {
  object: string
  user: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAuthorizationsAndInvites
// ====================================================

export interface AddAuthorizationsAndInvites {
  addAuthorizationsAndInvites: boolean
}

export interface AddAuthorizationsAndInvitesVariables {
  elementId: string
  emails: any[]
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserForTag
// ====================================================

export interface UserForTag_user {
  __typename: 'User'
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface UserForTag {
  user: UserForTag_user | null
}

export interface UserForTagVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchElementAuthorizations
// ====================================================

export interface FetchElementAuthorizations_element_MixedCollection_authorizations_Authorization_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface FetchElementAuthorizations_element_MixedCollection_authorizations_Authorization {
  __typename: 'Authorization'
  id: string
  user: FetchElementAuthorizations_element_MixedCollection_authorizations_Authorization_user
  value: number
}

export interface FetchElementAuthorizations_element_MixedCollection_authorizations_Invite {
  __typename: 'Invite'
  authorization: number | null
  id: string
}

export type FetchElementAuthorizations_element_MixedCollection_authorizations =
  | FetchElementAuthorizations_element_MixedCollection_authorizations_Authorization
  | FetchElementAuthorizations_element_MixedCollection_authorizations_Invite

export interface FetchElementAuthorizations_element_MixedCollection_paginatedAuthorizations {
  data: Array<
    | FetchElementAuthorizations_element_MixedCollection_authorizations_Authorization
    | FetchElementAuthorizations_element_MixedCollection_authorizations_Invite
  >;
  paginatorInfo: PaginatorInfo;
}

export interface FetchElementAuthorizations_element_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  authorizations: FetchElementAuthorizations_element_MixedCollection_authorizations[]
  paginatedAuthorizations: FetchElementAuthorizations_element_MixedCollection_paginatedAuthorizations
  selling: boolean
  sellingPricing: number | null
  sellingMethod: CollectionSellingMethodType
  need_registration: boolean
  creator: UserProfile & { email: any }
}

export interface FetchElementAuthorizations_element_AudioContent_authorizations_Authorization_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface FetchElementAuthorizations_element_AudioContent_authorizations_Authorization {
  __typename: 'Authorization'
  id: string
  user: FetchElementAuthorizations_element_AudioContent_authorizations_Authorization_user
  value: number
}

export interface FetchElementAuthorizations_element_AudioContent_authorizations_Invite {
  __typename: 'Invite'
  authorization: number | null
  id: string
}

export type FetchElementAuthorizations_element_AudioContent_authorizations =
  | FetchElementAuthorizations_element_AudioContent_authorizations_Authorization
  | FetchElementAuthorizations_element_AudioContent_authorizations_Invite

export interface FetchElementAuthorizations_element_AudioContent_paginatedAuthorizations {
  data: Array<
    | FetchElementAuthorizations_element_AudioContent_authorizations_Authorization
    | FetchElementAuthorizations_element_AudioContent_authorizations_Invite
  >;
  paginatorInfo: PaginatorInfo;
}

export interface FetchElementAuthorizations_element_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  authorizations: FetchElementAuthorizations_element_AudioContent_authorizations[]
  paginatedAuthorizations: FetchElementAuthorizations_element_AudioContent_paginatedAuthorizations
  creator: UserProfile & { email: any }
}

export type FetchElementAuthorizations_element =
  | FetchElementAuthorizations_element_MixedCollection
  | FetchElementAuthorizations_element_AudioContent

export interface FetchElementAuthorizations_knownUsers {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface FetchElementAuthorizations_user_emails {
  __typename: 'UserEmail';
  email: string;
  id: string;
  primary: boolean;
  verifiedAt: string | null;
}

export interface FetchElementAuthorizations_user {
  __typename: 'User';
  emails: FetchElementAuthorizations_user_emails[];
  id: string;
}

export interface FetchElementAuthorizations {
  user: FetchElementAuthorizations_user;
  element: FetchElementAuthorizations_element | null
  knownUsers: FetchElementAuthorizations_knownUsers[]
}

export interface FetchElementAuthorizationsVariables {
  id: string
  page?: number
  first?: number
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAuthorization
// ====================================================

export interface SetAuthorization_setAuthorization {
  __typename: 'Authorization'
  id: string
}

export interface SetAuthorization {
  setAuthorization: SetAuthorization_setAuthorization
}

export interface SetAuthorizationVariables {
  object: string
  user: string
  value: number
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAuthorization
// ====================================================

export interface RemoveAuthorization {
  removeAuthorization: boolean
}

export interface RemoveAuthorizationVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetInviteAuthorization
// ====================================================

export interface SetInviteAuthorization {
  setInviteAuthorization: boolean
}

export interface SetInviteAuthorizationVariables {
  elementId: string
  email: any
  value: number
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveInviteAuthorization
// ====================================================

export interface RemoveInviteAuthorization {
  removeInviteAuthorization: boolean
}

export interface RemoveInviteAuthorizationVariables {
  elementId: string
  email: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentNote
// ====================================================

export interface ContentNote_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Notes of the current user about this content
   */
  note: string | null
}

export interface ContentNote {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentNote_content | null
}

export interface ContentNoteVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContentNote
// ====================================================

export interface UpdateContentNote_updateContentNote {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Notes of the current user about this content
   */
  note: string | null
}

export interface UpdateContentNote {
  /**
   * Change notes related to content for current user
   */
  updateContentNote: UpdateContentNote_updateContentNote
}

export interface UpdateContentNoteVariables {
  id: string
  note?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddRegistration
// ====================================================

export interface AddRegistration_addEventContentRegistration_registeredUsers {
  __typename: 'User'
  id: string
}

export interface AddRegistration_addEventContentRegistration {
  __typename: 'EventContent'
  expired: any | null
  /**
   * Unique identifier
   */
  id: string
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: AddRegistration_addEventContentRegistration_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
}

export interface AddRegistration {
  addEventContentRegistration: AddRegistration_addEventContentRegistration
}

export interface AddRegistrationVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveRegistration
// ====================================================

export interface RemoveRegistration_removeEventContentRegistration_registeredUsers {
  __typename: 'User'
  id: string
}

export interface RemoveRegistration_removeEventContentRegistration {
  __typename: 'EventContent'
  expired: any | null
  /**
   * Unique identifier
   */
  id: string
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: RemoveRegistration_removeEventContentRegistration_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
}

export interface RemoveRegistration {
  removeEventContentRegistration: RemoveRegistration_removeEventContentRegistration
}

export interface RemoveRegistrationVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadFileForCarousel
// ====================================================

export interface UploadFileForCarousel {
  /**
   * Upload a file that is publicly available
   */
  upload: any
}

export interface UploadFileForCarouselVariables {
  file: any
  namespace: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StoredFileForCarousel
// ====================================================

export interface StoredFileForCarousel_storedFile {
  __typename: 'StoredFile'
  filename: string
  id: string
  isImage: boolean
  url: any
}

export interface StoredFileForCarousel {
  storedFile: StoredFileForCarousel_storedFile | null
}

export interface StoredFileForCarouselVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadInlineImage
// ====================================================

export interface UploadInlineImage {
  /**
   * Upload a file that is publicly available
   */
  upload: any
}

export interface UploadInlineImageVariables {
  file: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppFormPaymentsTab
// ====================================================

export interface AppFormPaymentsTab_user_stripeAccount {
  __typename: 'StripeAccount'
  /**
   * Three-letter ISO currency code representing the default currency for the account.
   */
  currency: string
  detailsSubmitted: boolean
  /**
   * Unique identifier for the object.
   */
  id: string
}

export interface AppFormPaymentsTab_user {
  __typename: 'User'
  id: string
  stripeAccount: AppFormPaymentsTab_user_stripeAccount
  stripeAccountLink: any
}

export interface AppFormPaymentsTab {
  /**
   * Currently authenticated user
   */
  user: AppFormPaymentsTab_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserTags
// ====================================================

export interface CurrentUserTags_me {
  __typename: 'User'
  id: string
  tags: string[]
}

export interface CurrentUserTags {
  /**
   * Currently authenticated user
   */
  me: CurrentUserTags_me | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadFile
// ====================================================

export interface UploadFile {
  /**
   * Upload a file that is publicly available
   */
  upload: any
}

export interface UploadFileVariables {
  file: any
  namespace: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StoredFile
// ====================================================

export interface StoredFile_storedFile {
  __typename: 'StoredFile'
  filename: string
  id: string
  isImage: boolean
  url: any
}

export interface StoredFile {
  storedFile: StoredFile_storedFile | null
}

export interface StoredFileVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppHeaderUserMenu
// ====================================================

export interface AppHeaderUserMenu_me {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  /**
   * First name
   */
  firstname: string
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface AppHeaderUserMenu {
  /**
   * Currently authenticated user
   */
  me: AppHeaderUserMenu_me | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppQuiz
// ====================================================

export interface AppQuiz_content_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Last update of the content
   */
  updatedAt: any
}

export interface AppQuiz_content_QuizContent_mySessions {
  __typename: 'QuizContentSession'
  id: string
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuiz_content_QuizContent_questions =
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionEssay
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionMissingWord
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionNumerical
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice
  | AppQuiz_content_QuizContent_questions_QuizContentQuestionTrueFalse

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuiz_content_QuizContent_session_questions =
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionEssay
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMissingWord
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionNumerical
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice
  | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionTrueFalse

export interface AppQuiz_content_QuizContent_session {
  __typename: 'QuizContentSession'
  answers: any
  completed: boolean
  id: string
  questions: AppQuiz_content_QuizContent_session_questions[]
  success: boolean
  points: any
}

export interface AppQuiz_content_QuizContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface AppQuiz_content_QuizContent {
  __typename: 'QuizContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Last update of the content
   */
  updatedAt: any
  canRepeat: boolean
  canRepeatMaximum: number | null
  canRepeatOnlyFailure: boolean
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  mySessions: AppQuiz_content_QuizContent_mySessions[]
  myLastSession: any
  questions: AppQuiz_content_QuizContent_questions[]
  quizFeedbackFailureImage: any | null
  quizFeedbackFailureMessage: string | null
  quizFeedbackSuccessImage: any | null
  quizFeedbackSuccessMessage: string | null
  separateEvaluation: boolean
  session: AppQuiz_content_QuizContent_session | null
  showSummary: boolean
  successPoints: number | null
  /**
   * Main title
   */
  title: string
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: AppQuiz_content_QuizContent_coverDimensions | null
  instructions: string | null
  tags: string[]
  timeLimit: number | null
  questionsNavigation: boolean
  showAnswer: boolean
  showProgress: boolean
  appendRequiredQuestions: boolean
  basket: number | null
  extractProgress: any | null
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  randomOrder: boolean
  restartFromBegin: boolean
}

export type AppQuiz_content =
  | AppQuiz_content_AudioContent
  | AppQuiz_content_QuizContent

export interface AppQuiz {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AppQuiz_content | null
}

export interface AppQuizVariables {
  identifier: string
  collectionIdentifier?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppQuizStateContextStorage
// ====================================================

export interface AppQuizStateContextStorage {
  storeQuizProgress: boolean
}

export interface AppQuizStateContextStorageVariables {
  id: string
  status: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeatureCondition
// ====================================================

export interface FeatureCondition {
  /**
   * Gets a feature flag, generic or for current user
   */
  enabled: boolean
}

export interface FeatureConditionVariables {
  feature: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GlobalFeatures
// ====================================================

export interface GlobalFeatures {
  /**
   * Gets a feature flag, generic or for current user
   */
  hasEvent: boolean
  /**
   * Gets a feature flag, generic or for current user
   */
  hasPayments: boolean
  /**
   * Gets a feature flag, generic or for current user
   */
  hasQuiz: boolean
  /**
   * Gets a feature flag, generic or for current user
   */
  hasUsersManagement: boolean
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendAdditionalEmailConfirmation
// ====================================================

export interface SendAdditionalEmailConfirmation {
  confirmAdditionalEmail: boolean
}

export interface SendAdditionalEmailConfirmationVariables {
  sha1: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionPageContents
// ====================================================

export interface CollectionPageContents_collection_contents_edges_node_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export interface CollectionPageContents_collection_contents_edges_node_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface CollectionPageContents_collection_contents_edges_node_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface CollectionPageContents_collection_contents_edges_node_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
}

export interface CollectionPageContents_collection_contents_edges_node_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface CollectionPageContents_collection_contents_edges_node_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionPageContents_collection_contents_edges_node_PdfContent_pdfDetails | null
}

export interface CollectionPageContents_collection_contents_edges_node_QuizContent_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface CollectionPageContents_collection_contents_edges_node_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  questions: CollectionPageContents_collection_contents_edges_node_QuizContent_questions[]
}

export interface CollectionPageContents_collection_contents_edges_node_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
}

export interface CollectionPageContents_collection_contents_edges_node_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  visibilityForCollection: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Destination link
   */
  url: any | null
  isProcessing: boolean
  aspectRatio: string | null
}

export type CollectionPageContents_collection_contents_edges_node =
  | CollectionPageContents_collection_contents_edges_node_AudioContent
  | CollectionPageContents_collection_contents_edges_node_EventContent
  | CollectionPageContents_collection_contents_edges_node_ImageContent
  | CollectionPageContents_collection_contents_edges_node_LinkContent
  | CollectionPageContents_collection_contents_edges_node_PdfContent
  | CollectionPageContents_collection_contents_edges_node_QuizContent
  | CollectionPageContents_collection_contents_edges_node_TextContent
  | CollectionPageContents_collection_contents_edges_node_VideoContent


export interface CollectionPageContents_collection_contents_edges {
  __typename: 'ContentEdge'
  /**
   * The Content node.
   */
  node: CollectionPageContents_collection_contents_edges_node
}

export interface CollectionPageContents_collection_contents {
  __typename: 'ContentConnection'
  /**
   * A list of Content edges.
   */
  edges: CollectionPageContents_collection_contents_edges[]
}

export interface CollectionPageContents_collection_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CollectionPageContents_collection_creator_stripeAccount {
  __typename: 'StripeAccount'
  /**
   * Unique identifier for the object.
   */
  id: string
}

export interface CollectionPageContents_collection_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
  subscriptionPlan: {
    id: string
    code: string
  }
  stripeAccount: CollectionPageContents_collection_creator_stripeAccount
  workspace: Workspace
}

export interface CollectionPageContents_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * List of all the contents included in subject collection
   */
  contents: CollectionPageContents_collection_contents | null
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean
  collectionDisplayStatus: CollectionDisplayStatus
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionPageContents_collection_coverDimensions | null
  /**
   * Collection creator
   */
  creator: CollectionPageContents_collection_creator
  label: string | null
  presentation: string | null
  selling: any
  sellingCurrency: string | null
  sellingMethod: string | null
  sellingPricing: number | null
  privacyPolicy: string | null
  tags: string[]
  need_registration: boolean
}

export interface CollectionPageContents_me_contents_pageInfo {
  __typename: 'PageInfo'
  /**
   * Total number of nodes in the paginated connection.
   */
  total: number
}

export interface CollectionPageContents_me_contents {
  __typename: 'ContentConnection'
  /**
   * Pagination information about the list of edges.
   */
  pageInfo: CollectionPageContents_me_contents_pageInfo
}

export interface CollectionPageContents_me {
  __typename: 'User'
  /**
   * Contents managed by the user
   */
  contents: CollectionPageContents_me_contents | null
  id: string
}

export interface CollectionPageContents {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionPageContents_collection | null
  /**
   * Currently authenticated user
   */
  me: CollectionPageContents_me | null
}

export interface CollectionPageContentsVariables {
  identifier: string
  token?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserContents
// ====================================================

export interface CurrentUserContents_me_contents_edges_node {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Determines if subject content is included in a collection
   */
  isInCollection: boolean
  /**
   * Main title
   */
  title: string
}

export interface CurrentUserContents_me_contents_edges {
  __typename: 'ContentEdge'
  /**
   * The Content node.
   */
  node: CurrentUserContents_me_contents_edges_node
}

export interface CurrentUserContents_me_contents {
  __typename: 'ContentConnection'
  /**
   * A list of Content edges.
   */
  edges: CurrentUserContents_me_contents_edges[]
}

export interface CurrentUserContents_me {
  __typename: 'User'
  /**
   * Contents managed by the user
   */
  contents: CurrentUserContents_me_contents | null
  id: string
}

export interface CurrentUserContents {
  /**
   * Currently authenticated user
   */
  me: CurrentUserContents_me | null
}

export interface CurrentUserContentsVariables {
  includes: string
  visibility?: Visibility[] | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleCollectionContentAssociation
// ====================================================

export interface ToggleCollectionContentAssociation {
  toggleContentCollectionAssociation: boolean
}

export interface ToggleCollectionContentAssociationVariables {
  associated: boolean
  collectionId: string
  contentId: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeCollectionContentsOrder
// ====================================================

export interface ChangeCollectionContentsOrder_changeCollectionContentsOrder {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
}

export interface ChangeCollectionContentsOrder {
  changeCollectionContentsOrder: ChangeCollectionContentsOrder_changeCollectionContentsOrder
}

export interface ChangeCollectionContentsOrderVariables {
  contentsId: string[]
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionContextElementsId
// ====================================================

export interface CollectionContextElementsId_collection_contents_edges_node {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface CollectionContextElementsId_collection_contents_edges {
  __typename: 'ContentEdge'
  /**
   * The Content node.
   */
  node: CollectionContextElementsId_collection_contents_edges_node
}

export interface CollectionContextElementsId_collection_contents {
  __typename: 'ContentConnection'
  /**
   * A list of Content edges.
   */
  edges: CollectionContextElementsId_collection_contents_edges[]
}

export interface CollectionContextElementsId_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * List of all the contents included in subject collection
   */
  contents: CollectionContextElementsId_collection_contents | null
  /**
   * Unique identifier
   */
  id: string
}

export interface CollectionContextElementsId {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionContextElementsId_collection | null
}

export interface CollectionContextElementsIdVariables {
  collectionIdentifier: string
  contentIdentifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContactFormPrefilledData
// ====================================================

export interface ContactFormPrefilledData_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
}

export interface ContactFormPrefilledData {
  /**
   * Currently authenticated user
   */
  user: ContactFormPrefilledData_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendCollectionSellingContactRequest
// ====================================================

export interface SendCollectionSellingContactRequest {
  sendCollectionSellingContactRequest: boolean
}

export interface SendCollectionSellingContactRequestVariables {
  input: SellingContactRequestInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OnlineFormAdditionalDetails
// ====================================================

export interface OnlineFormAdditionalDetails_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
}

export interface OnlineFormAdditionalDetails {
  /**
   * Currently authenticated user
   */
  user: OnlineFormAdditionalDetails_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OnlineFormCollectionDetails
// ====================================================

export interface OnlineFormCollectionDetails_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
  sellingCurrency: string | null
  sellingPricing: number | null
  privacyPolicy: string | null
  /**
   * Main title
   */
  title: string
}

export interface OnlineFormCollectionDetails {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: OnlineFormCollectionDetails_collection | null
}

export interface OnlineFormCollectionDetailsVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegisterCollectionSellingCreateRequest
// ====================================================

export interface RegisterCollectionSellingCreateRequest {
  registerCollectionSellingCreateRequest: boolean
}

export interface RegisterCollectionSellingCreateRequestVariables {
  collectionId: string
  paymentIntent: string
  paymentIntentClientSecret: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendCollectionSellingCreateRequest
// ====================================================

export interface SendCollectionSellingCreateRequest {
  secret: string
}

export interface SendCollectionSellingCreateRequestVariables {
  collectionId: string
  metadata?: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackCollectionVisit
// ====================================================

export interface TrackCollectionVisit_trackCollectionVisit {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
}

export interface TrackCollectionVisit {
  /**
   * Track collection visit by current user
   */
  trackCollectionVisit: TrackCollectionVisit_trackCollectionVisit
}

export interface TrackCollectionVisitVariables {
  id: string
  ip?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCollection
// ====================================================

export interface CreateCollection_createCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface CreateCollection {
  createCollection: CreateCollection_createCollection
}

export interface CreateCollectionVariables {
  input: CreateCollectionInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionForEdit
// ====================================================

export interface CollectionForEdit_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  presentation: string | null
  selling: boolean
  sellingCurrency: string | null
  sellingMethod: string | null
  sellingPricing: number | null
  privacyPolicy: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
}

export interface CollectionForEdit {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionForEdit_collection | null
}

export interface CollectionForEditVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCollection
// ====================================================

export interface UpdateCollection_updateCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface UpdateCollection {
  updateCollection: UpdateCollection_updateCollection
}

export interface UpdateCollectionVariables {
  id: string
  input: UpdateCollectionInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionStatusAnalytics
// ====================================================

export interface CollectionStatusAnalytics_collection_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface CollectionStatusAnalytics_collection {
  __typename: 'MixedCollection' | 'VideoCollection'
  history: CollectionStatusAnalytics_collection_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the collection
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the collection
   */
  totalUserVisitors: number
  /**
   * Total visitors to the collection
   */
  totalVisitors: number
  /**
   * Total visits to the collection
   */
  totalVisits: number
}

export interface CollectionStatusAnalytics {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionStatusAnalytics_collection | null
}

export interface CollectionStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackContentVisit
// ====================================================

export interface TrackContentVisit_trackContentVisit {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface TrackContentVisit {
  /**
   * Track content visit by current user
   */
  trackContentVisit: TrackContentVisit_trackContentVisit
}

export interface TrackContentVisitVariables {
  id: string
  ip?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentPage
// ====================================================

export interface ContentPage_content_EventContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_EventContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_EventContent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface ContentPage_content_EventContent_relatedContents_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface ContentPage_content_EventContent_relatedContents_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export interface ContentPage_content_EventContent_relatedContents_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface ContentPage_content_EventContent_relatedContents_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
}

export interface ContentPage_content_EventContent_relatedContents_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface ContentPage_content_EventContent_relatedContents_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * PDF document additional details
   */
  pdfDetails: ContentPage_content_EventContent_relatedContents_PdfContent_pdfDetails | null
}

export interface ContentPage_content_EventContent_relatedContents_QuizContent_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface ContentPage_content_EventContent_relatedContents_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  questions: ContentPage_content_EventContent_relatedContents_QuizContent_questions[]
}

export interface ContentPage_content_EventContent_relatedContents_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
}

export interface ContentPage_content_EventContent_relatedContents_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export type ContentPage_content_EventContent_relatedContents =
  | ContentPage_content_EventContent_relatedContents_EventContent
  | ContentPage_content_EventContent_relatedContents_AudioContent
  | ContentPage_content_EventContent_relatedContents_ImageContent
  | ContentPage_content_EventContent_relatedContents_LinkContent
  | ContentPage_content_EventContent_relatedContents_PdfContent
  | ContentPage_content_EventContent_relatedContents_QuizContent
  | ContentPage_content_EventContent_relatedContents_TextContent
  | ContentPage_content_EventContent_relatedContents_VideoContent

export interface ContentPage_content_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_EventContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_EventContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  eventStatusForMenu: EventContentStatus
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: ContentPage_content_EventContent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  presentation: string | null
  relatedContents: ContentPage_content_EventContent_relatedContents[]
}

export interface ContentPage_content_QuizContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_QuizContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_QuizContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_QuizContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
}

export interface ContentPage_content_AudioContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_AudioContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_AudioContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_AudioContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Total duration in seconds
   */
  duration: number | null
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentPage_content_ImageContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_ImageContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_ImageContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_ImageContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Content subtype
   */
  imageSubtype: string | null
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

export interface ContentPage_content_VideoContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_VideoContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_VideoContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_VideoContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Total duration in seconds
   */
  duration: number | null
  isProcessing: boolean
  /**
   * Destination link
   */
  url: any | null
  aspectRatio: string | null
}

export interface ContentPage_content_LinkContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_LinkContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_LinkContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_LinkContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentPage_content_PdfContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_PdfContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface ContentPage_content_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_PdfContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_PdfContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * PDF document additional details
   */
  pdfDetails: ContentPage_content_PdfContent_pdfDetails | null
  /**
   * Destination link
   */
  url: any | null
  canDownload: boolean
}

export interface ContentPage_content_TextContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPage_content_TextContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPage_content_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_TextContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPage_content_TextContent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Notes of the current user about this content
   */
  note: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  body: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
}

export type ContentPage_content =
  | ContentPage_content_EventContent
  | ContentPage_content_QuizContent
  | ContentPage_content_AudioContent
  | ContentPage_content_ImageContent
  | ContentPage_content_VideoContent
  | ContentPage_content_LinkContent
  | ContentPage_content_PdfContent
  | ContentPage_content_TextContent

export interface ContentPage {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentPage_content | null
}

export interface ContentPageVariables {
  collectionIdentifier?: string
  identifier: string
  token?: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContent
// ====================================================

export interface CreateContent_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface CreateContent {
  content: CreateContent_content
}

export interface CreateContentVariables {
  input: CreateContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEventContent
// ====================================================

export interface CreateEventContent_content {
  __typename: 'EventContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface CreateEventContent {
  content: CreateEventContent_content
}

export interface CreateEventContentVariables {
  input: CreateEventContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppCreateContentImage
// ====================================================

export interface AppCreateContentImage_content {
  __typename: 'ImageContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface AppCreateContentImage {
  content: AppCreateContentImage_content
}

export interface AppCreateContentImageVariables {
  input: CreateImageContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Oembed
// ====================================================

export interface Oembed_oEmbed {
  __typename: 'OEmbed'
  /**
   * The resource description
   */
  description: string | null
  /**
   * Canonical URL
   */
  id: any
  /**
   * A URL to a thumbnail image representing the resource.
   */
  image: any | null
  /**
   * A text title, describing the resource.
   */
  title: string | null
}

export interface Oembed {
  /**
   * Extract oEmbed data from URL
   * https: // oembed.com/
   */
  oEmbed: Oembed_oEmbed | null
}

export interface OembedVariables {
  url: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateQuizContent
// ====================================================

export interface CreateQuizContent_content {
  __typename: 'QuizContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface CreateQuizContent {
  content: CreateQuizContent_content
}

export interface CreateQuizContentVariables {
  input: CreateQuizContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTextContent
// ====================================================

export interface CreateTextContent_createTextContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface CreateTextContent {
  createTextContent: CreateTextContent_createTextContent
}

export interface CreateTextContentVariables {
  input: CreateTextContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentForEdit
// ====================================================

export interface ContentForEdit_content_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentForEdit_content_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  end: any | null
  /**
   * Content subtype
   */
  eventSubtype: EventContentSubtype
  location: string | null
  participants: number | null
  presentation: string | null
  registration: boolean
  start: any | null
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentForEdit_content_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentForEdit_content_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentForEdit_content_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  imageSubtype: string | null
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

export interface ContentForEdit_content_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  body: string
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentForEdit_content_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Destination link
   */
  url: any | null
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  timeLimit: number | null
  title: string | null
  type: QuizContentQuestionType
}

export type ContentForEdit_content_QuizContent_questions =
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionEssay
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionMissingWord
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionNumerical
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice
  | ContentForEdit_content_QuizContent_questions_QuizContentQuestionTrueFalse

export interface ContentForEdit_content_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  appendRequiredQuestions: boolean
  basket: number | null
  canRepeat: boolean
  canRepeatMaximum: number | null
  canRepeatOnlyFailure: boolean
  instructions: string | null
  questions: ContentForEdit_content_QuizContent_questions[]
  questionsNavigation: boolean
  quizFeedbackFailureImage: any | null
  quizFeedbackFailureMessage: string | null
  quizFeedbackSuccessImage: any | null
  quizFeedbackSuccessMessage: string | null
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  randomOrder: boolean
  restartFromBegin: boolean
  separateEvaluation: boolean
  showAnswer: boolean
  showProgress: boolean
  showSummary: boolean
  successPoints: number | null
  timeLimit: number | null
}

export type ContentForEdit_content =
  | ContentForEdit_content_AudioContent
  | ContentForEdit_content_EventContent
  | ContentForEdit_content_LinkContent
  | ContentForEdit_content_PdfContent
  | ContentForEdit_content_ImageContent
  | ContentForEdit_content_TextContent
  | ContentForEdit_content_VideoContent
  | ContentForEdit_content_QuizContent

export interface ContentForEdit {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentForEdit_content | null
}

export interface ContentForEditVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEventContent
// ====================================================

export interface UpdateEventContent_content {
  __typename: 'EventContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface UpdateEventContent {
  content: UpdateEventContent_content
}

export interface UpdateEventContentVariables {
  id: string
  input: UpdateEventContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateImageContent
// ====================================================

export interface UpdateImageContent_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface UpdateImageContent {
  content: UpdateImageContent_content
}

export interface UpdateImageContentVariables {
  id: string
  input: UpdateImageContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateQuizContent
// ====================================================

export interface UpdateQuizContent_content {
  __typename: 'QuizContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface UpdateQuizContent {
  content: UpdateQuizContent_content
}

export interface UpdateQuizContentVariables {
  id: string
  input: UpdateQuizContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateTextContent
// ====================================================

export interface UpdateTextContent_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface UpdateTextContent {
  content: UpdateTextContent_content
}

export interface UpdateTextContentVariables {
  id: string
  input: UpdateTextContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContent
// ====================================================

export interface UpdateContent_content {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
}

export interface UpdateContent {
  content: UpdateContent_content
}

export interface UpdateContentVariables {
  id: string
  input: UpdateContentInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppEventPresences
// ====================================================

export interface AppEventPresences_content_AudioContent {
  __typename:
    | 'AudioContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
}

export interface AppEventPresences_content_EventContent_presences_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface AppEventPresences_content_EventContent_presences {
  __typename: 'EventContentPresence'
  presence: boolean | null
  user: AppEventPresences_content_EventContent_presences_user
}

export interface AppEventPresences_content_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
  presences: AppEventPresences_content_EventContent_presences[]
}

export type AppEventPresences_content =
  | AppEventPresences_content_AudioContent
  | AppEventPresences_content_EventContent

export interface AppEventPresences {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AppEventPresences_content | null
}

export interface AppEventPresencesVariables {
  identifier: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppEventPresencesToggle
// ====================================================

export interface AppEventPresencesToggle_toggleEventContentUserPresence {
  __typename: 'EventContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface AppEventPresencesToggle {
  toggleEventContentUserPresence: AppEventPresencesToggle_toggleEventContentUserPresence
}

export interface AppEventPresencesToggleVariables {
  eventId: string
  presence: boolean
  userId: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppQuizSessionsEvaluation
// ====================================================

export interface AppQuizSessionsEvaluation_content_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
}

export interface AppQuizSessionsEvaluation_content_QuizContent_sessions_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
  id: string
}

export interface AppQuizSessionsEvaluation_content_QuizContent_sessions_quiz {
  __typename: 'QuizContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface AppQuizSessionsEvaluation_content_QuizContent_sessions_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

export interface AppQuizSessionsEvaluation_content_QuizContent_sessions {
  __typename: 'QuizContentSession'
  answers: any
  completed: boolean
  /**
   * When session was created
   */
  createdAt: any
  id: string
  points: any
  questions: AppQuizSessionsEvaluation_content_QuizContent_sessions_questions[]
  quiz: AppQuizSessionsEvaluation_content_QuizContent_sessions_quiz
  success: boolean
  user: AppQuizSessionsEvaluation_content_QuizContent_sessions_user
}

export interface PaginatorInfo {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
  count: number;
  hasMorePages: boolean;
}

export interface QuizContentSessionData {
  answers: string;
  completed: boolean;
  createdAt: string;
  id: string;
  points: string;
  questions: Array<{
    __typename: string;
    id: string;
  }>;
  quiz: {
    id: string;
  };
  success: boolean;
  user: {
    email: string;
    id: string;
    name: string;
    picture: string;
  };
}

export interface PaginatedQuizContentSessions {
  data: QuizContentSessionData[];
  paginatorInfo: PaginatorInfo;
}

export interface AppQuizSessionsEvaluation_content_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
  sessions: AppQuizSessionsEvaluation_content_QuizContent_sessions[]
  paginatedSessions: PaginatedQuizContentSessions;
}

export type AppQuizSessionsEvaluation_content =
  | AppQuizSessionsEvaluation_content_AudioContent
  | AppQuizSessionsEvaluation_content_QuizContent

export interface AppQuizSessionsEvaluation {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AppQuizSessionsEvaluation_content | null
}

export interface AppQuizSessionsEvaluationVariables {
  identifier: string;
  page?: number | null;
  first?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppQuizSession
// ====================================================

export interface AppQuizSession_session_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
  id: string
  title: string | null
}

export interface AppQuizSession_session_quiz {
  __typename: 'QuizContent'
  /**
   * Unique identifier
   */
  id: string
  /**
   * Main title
   */
  title: string
}

export interface AppQuizSession_session_user {
  __typename: 'User'
  id: string
  /**
   * Full name
   */
  name: string
}

export interface AppQuizSession_session {
  __typename: 'QuizContentSession'
  answers: any
  completed: boolean
  /**
   * When session was created
   */
  createdAt: any
  id: string
  points: any
  questions: AppQuizSession_session_questions[]
  quiz: AppQuizSession_session_quiz
  success: boolean
  user: AppQuizSession_session_user
}

export interface AppQuizSession {
  session: AppQuizSession_session | null
}

export interface AppQuizSessionVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuizSessionEvaluation
// ====================================================

export interface QuizSessionEvaluation_session_quiz {
  __typename: 'QuizContent'
  /**
   * Unique identifier
   */
  id: string
}

export interface QuizSessionEvaluation_session {
  __typename: 'QuizContentSession'
  id: string
  quiz: QuizSessionEvaluation_session_quiz
}

export interface QuizSessionEvaluation {
  session: QuizSessionEvaluation_session
}

export interface QuizSessionEvaluationVariables {
  id: string
  input: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentStatusAnalytics
// ====================================================

export interface ContentStatusAnalytics_content_EventContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface ContentStatusAnalytics_content_EventContent {
  __typename:
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'TextContent'
  history: ContentStatusAnalytics_content_EventContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
}

export interface ContentStatusAnalytics_content_AudioContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface ContentStatusAnalytics_content_AudioContent {
  __typename: 'AudioContent'
  history: ContentStatusAnalytics_content_AudioContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
  totalUsersCompleted: number
  totalUsersStarted: number
}

export interface ContentStatusAnalytics_content_QuizContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface ContentStatusAnalytics_content_QuizContent {
  __typename: 'QuizContent'
  history: ContentStatusAnalytics_content_QuizContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
  totalUsersCompleted: number
  totalUsersStarted: number
}

export interface ContentStatusAnalytics_content_VideoContent_history {
  __typename: 'AnalyticsTotalByLabel'
  label: string
  total: number
}

export interface ContentStatusAnalytics_content_VideoContent {
  __typename: 'VideoContent'
  history: ContentStatusAnalytics_content_VideoContent_history[]
  /**
   * Unique identifier
   */
  id: string
  /**
   * Total visitors to the content
   */
  totalGuestVisitors: number
  totalHomesContaining: number
  /**
   * Total visitors to the content
   */
  totalUserVisitors: number
  /**
   * Total visitors to the content
   */
  totalVisitors: number
  /**
   * Total visits to the content
   */
  totalVisits: number
  totalUsersCompleted: number
  totalUsersStarted: number
}

export type ContentStatusAnalytics_content =
  | ContentStatusAnalytics_content_EventContent
  | ContentStatusAnalytics_content_AudioContent
  | ContentStatusAnalytics_content_QuizContent
  | ContentStatusAnalytics_content_VideoContent

export interface ContentStatusAnalytics {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentStatusAnalytics_content | null
}

export interface ContentStatusAnalyticsVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HomeElements
// ====================================================

export interface HomeElements_elements_AudioContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_AudioContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface HomeElements_elements_EventContent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface HomeElements_elements_EventContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_EventContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  eventStatusForMenu: EventContentStatus
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: HomeElements_elements_EventContent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_EventContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_EventContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  tags: string[]
}

export interface HomeElements_elements_ImageContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_ImageContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_ImageContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_ImageContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Content subtype
   */
  imageSubtype: string | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

export interface HomeElements_elements_LinkContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_LinkContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_LinkContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_LinkContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface HomeElements_elements_PdfContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_PdfContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface HomeElements_elements_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_PdfContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_PdfContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * PDF document additional details
   */
  pdfDetails: HomeElements_elements_PdfContent_pdfDetails | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface HomeElements_elements_QuizContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_QuizContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionEssay {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionNumerical'
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  choices: HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices[]
  title: string | null
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  choices: HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[]
  title: string | null
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  isTrue: boolean
  title: string | null
}

export type HomeElements_elements_QuizContent_questions =
  | HomeElements_elements_QuizContent_questions_QuizContentQuestionEssay
  | HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice
  | HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice
  | HomeElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse

export interface HomeElements_elements_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_QuizContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_QuizContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  questions: HomeElements_elements_QuizContent_questions[]
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  tags: string[]
}

export interface HomeElements_elements_TextContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_TextContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_TextContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_TextContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface HomeElements_elements_VideoContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_VideoContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_VideoContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: HomeElements_elements_VideoContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  isProcessing: boolean
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface HomeElements_elements_MixedCollection_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface HomeElements_elements_MixedCollection_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface HomeElements_elements_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
  collectionDisplayStatus: CollectionDisplayStatus
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_MixedCollection_coverDimensions | null
  /**
   * Collection creator
   */
  creator: HomeElements_elements_MixedCollection_creator
  label: string | null
  tags: string[]
}

export type HomeElements_elements =
  | HomeElements_elements_AudioContent
  | HomeElements_elements_EventContent
  | HomeElements_elements_ImageContent
  | HomeElements_elements_LinkContent
  | HomeElements_elements_PdfContent
  | HomeElements_elements_QuizContent
  | HomeElements_elements_TextContent
  | HomeElements_elements_VideoContent
  | HomeElements_elements_MixedCollection

export interface HomeElements {
  /**
   * All homepage elements, including:
   *  * created contents
   *  * visited contents
   *  * created collections
   *  * visited collections
   *
   * If createdByMe is defined, elements will be filtered.
   */
  elements: HomeElements_elements[]
  /**
   * Total homepage elements, including:
   *  * created contents
   *  * visited contents
   *  * created collections
   *  * visited collections
   *
   * If createdByMe is defined, elements will be filtered.
   */
  totalElements: number
}

export interface HomeElementsVariables {
  createdByMe?: boolean | null
  limit?: number | null
  offset?: number | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: OnGrantedAuthorization
// ====================================================

export interface OnGrantedAuthorization_grantedAuthorization_object_AudioContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_AudioContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_EventContent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface OnGrantedAuthorization_grantedAuthorization_object_EventContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_EventContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  eventStatusForMenu: EventContentStatus
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: OnGrantedAuthorization_grantedAuthorization_object_EventContent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_EventContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_EventContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  tags: string[]
}

export interface OnGrantedAuthorization_grantedAuthorization_object_ImageContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_ImageContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_ImageContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_ImageContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Content subtype
   */
  imageSubtype: string | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

export interface OnGrantedAuthorization_grantedAuthorization_object_LinkContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_LinkContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_LinkContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_LinkContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_PdfContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_PdfContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface OnGrantedAuthorization_grantedAuthorization_object_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_PdfContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_PdfContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * PDF document additional details
   */
  pdfDetails: OnGrantedAuthorization_grantedAuthorization_object_PdfContent_pdfDetails | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionEssay {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionNumerical'
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  choices: OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionSingleChoice_choices[]
  title: string | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  choices: OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[]
  title: string | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  isTrue: boolean
  title: string | null
}

export type OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions =

    | OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionEssay
    | OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionSingleChoice
    | OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionMultipleChoice
    | OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions_QuizContentQuestionTrueFalse

export interface OnGrantedAuthorization_grantedAuthorization_object_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_QuizContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_QuizContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  questions: OnGrantedAuthorization_grantedAuthorization_object_QuizContent_questions[]
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  tags: string[]
}

export interface OnGrantedAuthorization_grantedAuthorization_object_TextContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_TextContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_TextContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_TextContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_VideoContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_VideoContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_VideoContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_VideoContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  isProcessing: boolean
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_MixedCollection_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_MixedCollection_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface OnGrantedAuthorization_grantedAuthorization_object_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
  collectionDisplayStatus: CollectionDisplayStatus
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: OnGrantedAuthorization_grantedAuthorization_object_MixedCollection_coverDimensions | null
  /**
   * Collection creator
   */
  creator: OnGrantedAuthorization_grantedAuthorization_object_MixedCollection_creator
  label: string | null
  tags: string[]
}

export type OnGrantedAuthorization_grantedAuthorization_object =
  | OnGrantedAuthorization_grantedAuthorization_object_AudioContent
  | OnGrantedAuthorization_grantedAuthorization_object_EventContent
  | OnGrantedAuthorization_grantedAuthorization_object_ImageContent
  | OnGrantedAuthorization_grantedAuthorization_object_LinkContent
  | OnGrantedAuthorization_grantedAuthorization_object_PdfContent
  | OnGrantedAuthorization_grantedAuthorization_object_QuizContent
  | OnGrantedAuthorization_grantedAuthorization_object_TextContent
  | OnGrantedAuthorization_grantedAuthorization_object_VideoContent
  | OnGrantedAuthorization_grantedAuthorization_object_MixedCollection

export interface OnGrantedAuthorization_grantedAuthorization {
  __typename: 'Authorization'
  id: string
  object: OnGrantedAuthorization_grantedAuthorization_object
}

export interface OnGrantedAuthorization {
  /**
   * Triggered when a new Authorization is added to the User
   */
  grantedAuthorization: OnGrantedAuthorization_grantedAuthorization | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserName
// ====================================================

export interface CurrentUserName_me {
  __typename: 'User'
  /**
   * First name
   */
  firstname: string
  id: string
}

export interface CurrentUserName {
  /**
   * Currently authenticated user
   */
  me: CurrentUserName_me | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TotalHomeElements
// ====================================================

export interface TotalHomeElements {
  /**
   * Total homepage elements, including:
   *  * created contents
   *  * visited contents
   *  * created collections
   *  * visited collections
   *
   * If createdByMe is defined, elements will be filtered.
   */
  totalElements: number
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TagsPageElements
// ====================================================

export interface TagsPageElements_elements_AudioContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_AudioContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface TagsPageElements_elements_EventContent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface TagsPageElements_elements_EventContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_EventContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  eventStatusForMenu: EventContentStatus
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: TagsPageElements_elements_EventContent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_EventContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_EventContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  tags: string[]
}

export interface TagsPageElements_elements_ImageContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_ImageContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_ImageContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_ImageContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Content subtype
   */
  imageSubtype: string | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

export interface TagsPageElements_elements_LinkContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_LinkContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_LinkContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_LinkContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface TagsPageElements_elements_PdfContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_PdfContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface TagsPageElements_elements_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_PdfContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_PdfContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * PDF document additional details
   */
  pdfDetails: TagsPageElements_elements_PdfContent_pdfDetails | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface TagsPageElements_elements_QuizContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_QuizContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionEssay {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionNumerical'
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  choices: TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices[]
  title: string | null
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  choices: TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[]
  title: string | null
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  isTrue: boolean
  title: string | null
}

export type TagsPageElements_elements_QuizContent_questions =
  | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionEssay
  | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice
  | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice
  | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse

export interface TagsPageElements_elements_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_QuizContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_QuizContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  questions: TagsPageElements_elements_QuizContent_questions[]
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  tags: string[]
}

export interface TagsPageElements_elements_TextContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_TextContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_TextContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_TextContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface TagsPageElements_elements_VideoContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_VideoContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_VideoContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_VideoContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  isProcessing: boolean
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface TagsPageElements_elements_MixedCollection_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface TagsPageElements_elements_MixedCollection_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface TagsPageElements_elements_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
  collectionDisplayStatus: CollectionDisplayStatus
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_MixedCollection_coverDimensions | null
  /**
   * Collection creator
   */
  creator: TagsPageElements_elements_MixedCollection_creator
  label: string | null
  tags: string[]
}

export type TagsPageElements_elements =
  | TagsPageElements_elements_AudioContent
  | TagsPageElements_elements_EventContent
  | TagsPageElements_elements_ImageContent
  | TagsPageElements_elements_LinkContent
  | TagsPageElements_elements_PdfContent
  | TagsPageElements_elements_QuizContent
  | TagsPageElements_elements_TextContent
  | TagsPageElements_elements_VideoContent
  | TagsPageElements_elements_MixedCollection

export interface TagsPageElements {
  elements: TagsPageElements_elements[]
}

export interface TagsPageElementsVariables {
  tag: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserExternalAccounts
// ====================================================

export interface CurrentUserExternalAccounts_user_externalAccounts_edges_node {
  __typename: 'UserExternalAccount'
  createdAt: any
  expires: any | null
  id: string
  identifier: string
  isExpired: boolean
  provider: UserExternalAccountProvider
}

export interface CurrentUserExternalAccounts_user_externalAccounts_edges {
  __typename: 'UserExternalAccountEdge'
  /**
   * The UserExternalAccount node.
   */
  node: CurrentUserExternalAccounts_user_externalAccounts_edges_node
}

export interface CurrentUserExternalAccounts_user_externalAccounts {
  __typename: 'UserExternalAccountConnection'
  /**
   * A list of UserExternalAccount edges.
   */
  edges: CurrentUserExternalAccounts_user_externalAccounts_edges[]
}

export interface CurrentUserExternalAccounts_user {
  __typename: 'User'
  externalAccounts: CurrentUserExternalAccounts_user_externalAccounts | null
  id: string
}

export interface CurrentUserExternalAccounts {
  /**
   * Currently authenticated user
   */
  user: CurrentUserExternalAccounts_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DisconnectUserExternalAccount
// ====================================================

export interface DisconnectUserExternalAccount {
  disconnectUserExternalAccount: boolean
}

export interface DisconnectUserExternalAccountVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddUserEmailAddress
// ====================================================

export interface AddUserEmailAddress_addUserEmail {
  __typename: 'UserEmail'
  id: string
}

export interface AddUserEmailAddress {
  addUserEmail: AddUserEmailAddress_addUserEmail
}

export interface AddUserEmailAddressVariables {
  email: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserEmailAddresses
// ====================================================

export interface CurrentUserEmailAddresses_user_emails {
  __typename: 'UserEmail'
  email: any
  id: string
  primary: boolean
  verifiedAt: any | null
}

export interface CurrentUserEmailAddresses_user {
  __typename: 'User'
  emails: CurrentUserEmailAddresses_user_emails[]
  id: string
}

export interface CurrentUserEmailAddresses {
  /**
   * Currently authenticated user
   */
  user: CurrentUserEmailAddresses_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MakeUserEmailPrimary
// ====================================================

export interface MakeUserEmailPrimary_makeUserEmailPrimary {
  __typename: 'UserEmail'
  id: string
  primary: boolean
}

export interface MakeUserEmailPrimary {
  makeUserEmailPrimary: MakeUserEmailPrimary_makeUserEmailPrimary
}

export interface MakeUserEmailPrimaryVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveUserEmail
// ====================================================

export interface RemoveUserEmail {
  removeUserEmail: boolean
}

export interface RemoveUserEmailVariables {
  id: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchOriginalPicture
// ====================================================

export interface FetchOriginalPicture_user {
  __typename: 'User'
  id: string
  picture: any | null
}

export interface FetchOriginalPicture {
  /**
   * Currently authenticated user
   */
  user: FetchOriginalPicture_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadFileForPicture
// ====================================================

export interface UploadFileForPicture {
  /**
   * Upload a file that is publicly available
   */
  upload: any
}

export interface UploadFileForPictureVariables {
  file: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserPersonalInfomation
// ====================================================

export interface UpdateUserPersonalInfomation_updateUser {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  /**
   * First name
   */
  firstname: string
  id: string
  /**
   * Last name
   */
  lastname: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface UpdateUserPersonalInfomation {
  /**
   * Update current user profile
   */
  updateUser: UpdateUserPersonalInfomation_updateUser
}

export interface UpdateUserPersonalInfomationVariables {
  input: UpdateUserInput
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserPersonalInfomation
// ====================================================

export interface UserPersonalInfomation_user {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  /**
   * First name
   */
  firstname: string
  id: string
  /**
   * Last name
   */
  lastname: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface UserPersonalInfomation {
  /**
   * Currently authenticated user
   */
  user: UserPersonalInfomation_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserStripe
// ====================================================

export interface UserStripe_user_stripeAccount {
  __typename: 'StripeAccount'
  detailsSubmitted: boolean
  /**
   * Unique identifier for the object.
   */
  id: string
}

export interface UserStripe_user {
  __typename: 'User'
  id: string
  stripeAccount: UserStripe_user_stripeAccount
  stripeAccountLink: any
}

export interface UserStripe {
  /**
   * Currently authenticated user
   */
  user: UserStripe_user | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardCollection
// ====================================================

export interface CardCollection_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardCollection_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
  collectionDisplayStatus: CollectionDisplayStatus
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardCollection_coverDimensions | null
  /**
   * Collection creator
   */
  creator: CardCollection_creator
  label: string | null
  tags: string[]
  selling: string
  sellingPricing: number
  sellingCurrency: string
  need_registration: boolean
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardCollectionShareWrapperData
// ====================================================

export interface CardCollectionShareWrapperData {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContent
// ====================================================

export interface CardContent_EventContent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface CardContent_EventContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_EventContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  eventStatusForMenu: EventContentStatus
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: CardContent_EventContent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_EventContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_EventContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  tags: string[]
}

export interface CardContent_QuizContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_QuizContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_QuizContent_questions_QuizContentQuestionEssay {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionNumerical'
}

export interface CardContent_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface CardContent_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  choices: CardContent_QuizContent_questions_QuizContentQuestionSingleChoice_choices[]
  title: string | null
}

export interface CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  choices: CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[]
  title: string | null
}

export interface CardContent_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  isTrue: boolean
  title: string | null
}

export type CardContent_QuizContent_questions =
  | CardContent_QuizContent_questions_QuizContentQuestionEssay
  | CardContent_QuizContent_questions_QuizContentQuestionSingleChoice
  | CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice
  | CardContent_QuizContent_questions_QuizContentQuestionTrueFalse

export interface CardContent_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_QuizContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_QuizContent_creator
  displayStatus: ContentDisplayStatus
  label: string | null
  questions: CardContent_QuizContent_questions[]
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  tags: string[]
}

export interface CardContent_AudioContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Content creator
   */
  creator: CardContent_AudioContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface CardContent_ImageContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_ImageContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_ImageContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_ImageContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Content subtype
   */
  imageSubtype: string | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

export interface CardContent_LinkContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_LinkContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_LinkContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_LinkContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface CardContent_PdfContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_PdfContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface CardContent_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_PdfContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_PdfContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * PDF document additional details
   */
  pdfDetails: CardContent_PdfContent_pdfDetails | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface CardContent_TextContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_TextContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_TextContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_TextContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export interface CardContent_VideoContent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContent_VideoContent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContent_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_VideoContent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContent_VideoContent_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  isProcessing: boolean
  label: string | null
  tags: string[]
  /**
   * Destination link
   */
  url: any | null
}

export type CardContent =
  | CardContent_EventContent
  | CardContent_QuizContent
  | CardContent_AudioContent
  | CardContent_ImageContent
  | CardContent_LinkContent
  | CardContent_PdfContent
  | CardContent_TextContent
  | CardContent_VideoContent

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentShareWrapperData
// ====================================================

export interface CardContentShareWrapperData {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentAudio
// ====================================================

export interface CardContentAudio_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentAudio {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Content creator
   */
  creator: CardContentAudio_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentEvent
// ====================================================

export interface CardContentEvent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface CardContentEvent_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentEvent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentEvent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  expired: any | null
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: CardContentEvent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentEvent_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentEvent_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentImage
// ====================================================

export interface CardContentImage_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentImage_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentImage {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentImage_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentImage_creator
  displayStatus: ContentDisplayStatus
  /**
   * Content subtype
   */
  imageSubtype: string | null
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentLink
// ====================================================

export interface CardContentLink_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentLink_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentLink {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentLink_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentLink_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentPdf
// ====================================================

export interface CardContentPdf_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentPdf_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentPdf_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface CardContentPdf {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentPdf_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentPdf_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * PDF document additional details
   */
  pdfDetails: CardContentPdf_pdfDetails | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentQuiz
// ====================================================

export interface CardContentQuiz_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentQuiz_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentQuiz_questions_QuizContentQuestionEssay {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionNumerical'
}

export interface CardContentQuiz_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface CardContentQuiz_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  choices: CardContentQuiz_questions_QuizContentQuestionSingleChoice_choices[]
  title: string | null
}

export interface CardContentQuiz_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface CardContentQuiz_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  choices: CardContentQuiz_questions_QuizContentQuestionMultipleChoice_choices[]
  title: string | null
}

export interface CardContentQuiz_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  isTrue: boolean
  title: string | null
}

export type CardContentQuiz_questions =
  | CardContentQuiz_questions_QuizContentQuestionEssay
  | CardContentQuiz_questions_QuizContentQuestionSingleChoice
  | CardContentQuiz_questions_QuizContentQuestionMultipleChoice
  | CardContentQuiz_questions_QuizContentQuestionTrueFalse

export interface CardContentQuiz {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentQuiz_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentQuiz_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  label: string | null
  questions: CardContentQuiz_questions[]
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentText
// ====================================================

export interface CardContentText_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentText_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentText {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentText_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentText_creator
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentVideo
// ====================================================

export interface CardContentVideo_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardContentVideo_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface CardContentVideo {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentVideo_coverDimensions | null
  /**
   * Content creator
   */
  creator: CardContentVideo_creator
  /**
   * Main description, if given
   */
  description: string | null
  displayStatus: ContentDisplayStatus
  /**
   * Total duration in seconds
   */
  duration: number | null
  isProcessing: boolean
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
  aspectRatio: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MenuItems
// ====================================================

export interface MenuItems_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export interface MenuItems_AudioContent {
  __typename:
    | 'AudioContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export interface MenuItems_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  eventStatusForMenu: EventContentStatus
}

export interface MenuItems_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null
}

export type MenuItems =
  | MenuItems_MixedCollection
  | MenuItems_AudioContent
  | MenuItems_EventContent
  | MenuItems_QuizContent

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardNavBarActionBar
// ====================================================

export interface CardNavBarActionBar_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export interface CardNavBarActionBar_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export type CardNavBarActionBar =
  | CardNavBarActionBar_MixedCollection
  | CardNavBarActionBar_AudioContent

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardNavBar
// ====================================================

export interface CardNavBar_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export interface CardNavBar_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export type CardNavBar = CardNavBar_MixedCollection | CardNavBar_AudioContent

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardNavBarStatusBar
// ====================================================

export interface CardNavBarStatusBar_MixedCollection {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export interface CardNavBarStatusBar_AudioContent {
  __typename:
    | 'AudioContent'
    | 'EventContent'
    | 'ImageContent'
    | 'LinkContent'
    | 'PdfContent'
    | 'QuizContent'
    | 'TextContent'
    | 'VideoContent'
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export type CardNavBarStatusBar =
  | CardNavBarStatusBar_MixedCollection
  | CardNavBarStatusBar_AudioContent

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddUserSuggestion
// ====================================================

export interface AddUserSuggestion {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FetchElementAuthorizationsAuthorization
// ====================================================

export interface FetchElementAuthorizationsAuthorization_user {
  __typename: 'User'
  /**
   * Main email address
   */
  email: any
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  getCompletedAt: any
  hasUserVisited: boolean
}

export interface FetchElementAuthorizationsAuthorization {
  __typename: 'Authorization'
  id: string
  user: FetchElementAuthorizationsAuthorization_user
  value: number
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FetchElementAuthorizationsInvite
// ====================================================

export interface FetchElementAuthorizationsInvite {
  __typename: 'Invite'
  authorization: number | null
  id: string
  createdAt: any
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoverDimensions
// ====================================================

export interface CoverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EventCallToAction
// ====================================================

export interface EventCallToAction_registeredUsers {
  __typename: 'User'
  id: string
}

export interface EventCallToAction {
  __typename: 'EventContent'
  canManage: boolean
  expired: any | null
  /**
   * Unique identifier
   */
  id: string
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: EventCallToAction_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemAudio
// ====================================================

export interface ItemAudio {
  __typename: 'AudioContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CollectionInfo
// ====================================================

export interface CollectionInfo {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemDateRange
// ====================================================

export interface ItemDateRange {
  __typename: 'EventContent'
  end: any | null
  start: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemEvent
// ====================================================

export interface ItemEvent {
  __typename: 'EventContent'
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemImage
// ====================================================

export interface ItemImage {
  __typename: 'ImageContent'
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemLink
// ====================================================

export interface ItemLink {
  __typename: 'LinkContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemLocationOrUrl
// ====================================================

export interface ItemLocationOrUrl {
  __typename: 'EventContent'
  location: string | null
  /**
   * Destination link
   */
  url: any | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemPdf
// ====================================================

export interface ItemPdf_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface ItemPdf {
  __typename: 'PdfContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * PDF document additional details
   */
  pdfDetails: ItemPdf_pdfDetails | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemQuiz
// ====================================================

export interface ItemQuiz_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface ItemQuiz {
  __typename: 'QuizContent'
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  questions: ItemQuiz_questions[]
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemText
// ====================================================

export interface ItemText {
  __typename: 'TextContent'
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  label: string | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserProfile
// ====================================================

export interface UserProfile {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
  subscriptionPlan?: {
    id: string
    code: string
  } | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemVideo
// ====================================================

export interface ItemVideo {
  __typename: 'VideoContent'
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Total duration in seconds
   */
  duration: number | null
  label: string | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsage
// ====================================================

export interface AppQuizUsage_mySessions {
  __typename: 'QuizContentSession'
  id: string
}

export interface AppQuizUsage_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuizUsage_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuizUsage_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsage_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsage_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsage_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsage_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuizUsage_questions =
  | AppQuizUsage_questions_QuizContentQuestionEssay
  | AppQuizUsage_questions_QuizContentQuestionMatching
  | AppQuizUsage_questions_QuizContentQuestionMissingWord
  | AppQuizUsage_questions_QuizContentQuestionMultipleChoice
  | AppQuizUsage_questions_QuizContentQuestionNumerical
  | AppQuizUsage_questions_QuizContentQuestionSingleChoice
  | AppQuizUsage_questions_QuizContentQuestionTrueFalse

export interface AppQuizUsage_session_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuizUsage_session_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_session_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_session_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsage_session_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsage_session_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsage_session_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuizUsage_session_questions =
  | AppQuizUsage_session_questions_QuizContentQuestionEssay
  | AppQuizUsage_session_questions_QuizContentQuestionMatching
  | AppQuizUsage_session_questions_QuizContentQuestionMissingWord
  | AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice
  | AppQuizUsage_session_questions_QuizContentQuestionNumerical
  | AppQuizUsage_session_questions_QuizContentQuestionSingleChoice
  | AppQuizUsage_session_questions_QuizContentQuestionTrueFalse

export interface AppQuizUsage_session {
  __typename: 'QuizContentSession'
  answers: any
  completed: boolean
  id: string
  questions: AppQuizUsage_session_questions[]
  success: boolean
}

export interface AppQuizUsage_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface AppQuizUsage {
  __typename: 'QuizContent'
  canRepeat: boolean
  canRepeatMaximum: number | null
  canRepeatOnlyFailure: boolean
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  mySessions: AppQuizUsage_mySessions[]
  questions: AppQuizUsage_questions[]
  quizFeedbackFailureImage: any | null
  quizFeedbackFailureMessage: string | null
  quizFeedbackSuccessImage: any | null
  quizFeedbackSuccessMessage: string | null
  separateEvaluation: boolean
  session: AppQuizUsage_session | null
  showSummary: boolean
  successPoints: number | null
  /**
   * Main title
   */
  title: string
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: AppQuizUsage_coverDimensions | null
  instructions: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  timeLimit: number | null
  questionsNavigation: boolean
  showAnswer: boolean
  showProgress: boolean
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageCompletion
// ====================================================

export interface AppQuizUsageCompletion_mySessions {
  __typename: 'QuizContentSession'
  id: string
}

export interface AppQuizUsageCompletion_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuizUsageCompletion_session_questions =
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionEssay
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionMissingWord
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionNumerical
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice
  | AppQuizUsageCompletion_session_questions_QuizContentQuestionTrueFalse

export interface AppQuizUsageCompletion_session {
  __typename: 'QuizContentSession'
  answers: any
  completed: boolean
  id: string
  questions: AppQuizUsageCompletion_session_questions[]
  success: boolean
  points: any
}

export interface AppQuizUsageCompletion {
  __typename: 'QuizContent'
  canRepeat: boolean
  canRepeatMaximum: number | null
  canRepeatOnlyFailure: boolean
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  mySessions: AppQuizUsageCompletion_mySessions[]
  questions: AppQuizUsageCompletion_questions[]
  quizFeedbackFailureImage: any | null
  quizFeedbackFailureMessage: string | null
  quizFeedbackSuccessImage: any | null
  quizFeedbackSuccessMessage: string | null
  separateEvaluation: boolean
  session: AppQuizUsageCompletion_session | null
  showSummary: boolean
  successPoints: number | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageCover
// ====================================================

export interface AppQuizUsageCover_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface AppQuizUsageCover_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface AppQuizUsageCover {
  __typename: 'QuizContent'
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: AppQuizUsageCover_coverDimensions | null
  /**
   * Main description, if given
   */
  description: string | null
  instructions: string | null
  label: string | null
  questions: AppQuizUsageCover_questions[]
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  timeLimit: number | null
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestions
// ====================================================

export interface AppQuizUsageQuestions_questions_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuizUsageQuestions_questions_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuizUsageQuestions_questions =
  | AppQuizUsageQuestions_questions_QuizContentQuestionEssay
  | AppQuizUsageQuestions_questions_QuizContentQuestionMatching
  | AppQuizUsageQuestions_questions_QuizContentQuestionMissingWord
  | AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice
  | AppQuizUsageQuestions_questions_QuizContentQuestionNumerical
  | AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice
  | AppQuizUsageQuestions_questions_QuizContentQuestionTrueFalse

export interface AppQuizUsageQuestions {
  __typename: 'QuizContent'
  label: string | null
  questions: AppQuizUsageQuestions_questions[]
  questionsNavigation: boolean
  showAnswer: boolean
  showProgress: boolean
  timeLimit: number | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestion
// ====================================================

export interface AppQuizUsageQuestion_QuizContentQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestion_QuizContentQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuizUsageQuestion_QuizContentQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuizUsageQuestion_QuizContentQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestion_QuizContentQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestion_QuizContentQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageQuestion_QuizContentQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageQuestion_QuizContentQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestion_QuizContentQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestion_QuizContentQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageQuestion_QuizContentQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageQuestion_QuizContentQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export interface AppQuizUsageQuestion_QuizContentQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
  timeLimit: number | null
}

export type AppQuizUsageQuestion =
  | AppQuizUsageQuestion_QuizContentQuestionEssay
  | AppQuizUsageQuestion_QuizContentQuestionMatching
  | AppQuizUsageQuestion_QuizContentQuestionMissingWord
  | AppQuizUsageQuestion_QuizContentQuestionMultipleChoice
  | AppQuizUsageQuestion_QuizContentQuestionNumerical
  | AppQuizUsageQuestion_QuizContentQuestionSingleChoice
  | AppQuizUsageQuestion_QuizContentQuestionTrueFalse

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionEssay
// ====================================================

export interface AppQuizUsageQuestionEssay {
  __typename: 'QuizContentQuestionEssay'
  canBeSkipped: boolean | null
  id: string
  image: any | null
  missingPoints: number | null
  title: string | null
  successPoints?: number | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionMatching
// ====================================================

export interface AppQuizUsageQuestionMatching_matchPairs {
  __typename: 'QuizContentQuestionMatchingRow'
  subanswer: string
  subquestion: string
}

export interface AppQuizUsageQuestionMatching {
  __typename: 'QuizContentQuestionMatching'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  matchPairs: AppQuizUsageQuestionMatching_matchPairs[]
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionMissingWord
// ====================================================

export interface AppQuizUsageQuestionMissingWord {
  __typename: 'QuizContentQuestionMissingWord'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionMultipleChoice
// ====================================================

export interface AppQuizUsageQuestionMultipleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageQuestionMultipleChoice {
  __typename: 'QuizContentQuestionMultipleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageQuestionMultipleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionNumerical
// ====================================================

export interface AppQuizUsageQuestionNumerical {
  __typename: 'QuizContentQuestionNumerical'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  number: number
  range: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionSingleChoice
// ====================================================

export interface AppQuizUsageQuestionSingleChoice_choices {
  __typename: 'QuizContentQuestionTextChoice'
  isCorrect: boolean
  text: string
}

export interface AppQuizUsageQuestionSingleChoice {
  __typename: 'QuizContentQuestionSingleChoice'
  canBeSkipped: boolean | null
  choices: AppQuizUsageQuestionSingleChoice_choices[]
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionTrueFalse
// ====================================================

export interface AppQuizUsageQuestionTrueFalse {
  __typename: 'QuizContentQuestionTrueFalse'
  canBeSkipped: boolean | null
  failureFeedback: string | null
  failurePoints: number | null
  id: string
  image: any | null
  isTrue: boolean
  missingPoints: number | null
  successFeedback: string | null
  successPoints: number | null
  title: string | null
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardDetails
// ====================================================

export interface CardDetails_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface CardDetails_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
  subscriptionPlan: {
    id: string
    code: string
  }
  workspace: Workspace | null
}

export interface CardDetails {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null
  /**
   * Get total contents for required type
   */
  totalAudio: number
  /**
   * Get total contents for required type
   */
  totalImage: number
  /**
   * Get total contents for required type
   */
  totalLink: number
  /**
   * Get total contents for required type
   */
  totalPdf: number
  /**
   * Get total contents for required type
   */
  totalQuiz: number
  /**
   * Get total contents for required type
   */
  totalText: number
  /**
   * Get total contents for required type
   */
  totalVideo: number
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  /**
   * Cover picture
   */
  cover: any | null
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardDetails_coverDimensions | null
  /**
   * Collection creator
   */
  creator: CardDetails_creator
  /**
   * Main description, if given
   */
  description: string | null
  label: string | null
  tags: string[]
  /**
   * Main title
   */
  title: string
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CollectionContents
// ====================================================

export interface CollectionContents_contents_edges_node_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export interface CollectionContents_contents_edges_node_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface CollectionContents_contents_edges_node_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface CollectionContents_contents_edges_node_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
}

export interface CollectionContents_contents_edges_node_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface CollectionContents_contents_edges_node_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionContents_contents_edges_node_PdfContent_pdfDetails | null
}

export interface CollectionContents_contents_edges_node_QuizContent_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface CollectionContents_contents_edges_node_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  questions: CollectionContents_contents_edges_node_QuizContent_questions[]
}

export interface CollectionContents_contents_edges_node_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
}

export interface CollectionContents_contents_edges_node_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export type CollectionContents_contents_edges_node =
  | CollectionContents_contents_edges_node_AudioContent
  | CollectionContents_contents_edges_node_EventContent
  | CollectionContents_contents_edges_node_ImageContent
  | CollectionContents_contents_edges_node_LinkContent
  | CollectionContents_contents_edges_node_PdfContent
  | CollectionContents_contents_edges_node_QuizContent
  | CollectionContents_contents_edges_node_TextContent
  | CollectionContents_contents_edges_node_VideoContent

export interface CollectionContents_modules_edges_node {
  id: string
  title: string
  position: number
  contents: CollectionContents_contents | null
}

export interface CollectionContents_contents_edges {
  __typename: 'ContentEdge'
  /**
   * The Content node.
   */
  node: CollectionContents_contents_edges_node & {visibilityForCollection: Visibility, canManage: boolean}
}

export interface CollectionContents_modules_edges {
  __typename: 'ModuleEdge'
  /**
   * The Content node.
   */
  node: CollectionContents_modules_edges_node
}

export interface CollectionContents_contents {
  __typename: 'ContentConnection'
  /**
   * A list of Content edges.
   */
  edges: CollectionContents_contents_edges[]
}

export interface CollectionContents_modules {
  __typename: 'ModuleConnection'
  /**
   * A list of Content edges.
   */
  edges: CollectionContents_modules_edges[]
}

export interface CollectionContents {
  __typename: 'MixedCollection' | 'VideoCollection'
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean
  canRead: boolean
  /**
   * List of all the contents included in subject collection
   */
  contents: CollectionContents_contents | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility

  modules?: CollectionContents_modules | null
  creator: {
    brandName: string
    brandLogoSmall: string
  }
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPageEvent
// ====================================================

export interface ContentPageEvent_registeredUsers {
  __typename: 'User'
  id: string
}

export interface ContentPageEvent_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPageEvent_relatedContents_EventContent {
  __typename: 'EventContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface ContentPageEvent_relatedContents_AudioContent {
  __typename: 'AudioContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export interface ContentPageEvent_relatedContents_ImageContent {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
}

export interface ContentPageEvent_relatedContents_LinkContent {
  __typename: 'LinkContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Destination domain
   */
  domain: string | null
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null
}

export interface ContentPageEvent_relatedContents_PdfContent_pdfDetails {
  __typename: 'PdfDetails'
  pages: number
}

export interface ContentPageEvent_relatedContents_PdfContent {
  __typename: 'PdfContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * PDF document additional details
   */
  pdfDetails: ContentPageEvent_relatedContents_PdfContent_pdfDetails | null
}

export interface ContentPageEvent_relatedContents_QuizContent_questions {
  __typename:
    | 'QuizContentQuestionEssay'
    | 'QuizContentQuestionMatching'
    | 'QuizContentQuestionMissingWord'
    | 'QuizContentQuestionMultipleChoice'
    | 'QuizContentQuestionNumerical'
    | 'QuizContentQuestionSingleChoice'
    | 'QuizContentQuestionTrueFalse'
}

export interface ContentPageEvent_relatedContents_QuizContent {
  __typename: 'QuizContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  questions: ContentPageEvent_relatedContents_QuizContent_questions[]
}

export interface ContentPageEvent_relatedContents_TextContent {
  __typename: 'TextContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
}

export interface ContentPageEvent_relatedContents_VideoContent {
  __typename: 'VideoContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  label: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  /**
   * Main title
   */
  title: string
  /**
   * Total duration in seconds
   */
  duration: number | null
}

export type ContentPageEvent_relatedContents =
  | ContentPageEvent_relatedContents_EventContent
  | ContentPageEvent_relatedContents_AudioContent
  | ContentPageEvent_relatedContents_ImageContent
  | ContentPageEvent_relatedContents_LinkContent
  | ContentPageEvent_relatedContents_PdfContent
  | ContentPageEvent_relatedContents_QuizContent
  | ContentPageEvent_relatedContents_TextContent
  | ContentPageEvent_relatedContents_VideoContent

export interface ContentPageEvent {
  __typename: 'EventContent'
  expired: any | null
  /**
   * Unique identifier
   */
  id: string
  isCurrentUserRegistered: boolean
  participants: number | null
  registeredUsers: ContentPageEvent_registeredUsers[]
  registration: boolean
  status: EventContentStatus
  /**
   * Content subtype
   */
  subtype: EventContentSubtype
  /**
   * Destination link
   */
  url: any | null
  end: any | null
  start: any | null
  location: string | null
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Content creator
   */
  creator: ContentPageEvent_creator
  /**
   * Main description, if given
   */
  description: string | null
  presentation: string | null
  relatedContents: ContentPageEvent_relatedContents[]
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPageImage
// ====================================================

export interface ContentPageImage_coverDimensions {
  __typename: 'CoverDimensions'
  height: number | null
  width: number | null
}

export interface ContentPageImage_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPageImage {
  __typename: 'ImageContent'
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPageImage_coverDimensions | null
  /**
   * Content creator
   */
  creator: ContentPageImage_creator
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Content subtype
   */
  imageSubtype: string | null
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Destination link
   */
  url: any | null
  /**
   * Effective images URL
   */
  urls: any[]
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPageText
// ====================================================

export interface ContentPageText_creator {
  __typename: 'User'
  /**
   * Self description of the user
   */
  bio: string | null
  vanity_name: string | null
  id: string
  /**
   * Full name
   */
  name: string
  /**
   * User picture, if not set defaults to:
   *  * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   *  * an avatar with name initials
   */
  picture: any
  /**
   * Website or profile page
   */
  website: any | null
}

export interface ContentPageText {
  __typename: 'TextContent'
  body: string
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean
  /**
   * Content creator
   */
  creator: ContentPageText_creator
  /**
   * Main description, if given
   */
  description: string | null
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null
  /**
   * Unique identifier
   */
  id: string
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string
  tags: string[]
  /**
   * Main title
   */
  title: string
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility
}

export enum DomainStatus {
  pending = 'pending',
  active = 'active',
  failed = 'failed',
}

export interface CreateDomainPayload {
  domain: Domain
  resultCode: number
  message: string
}

export interface Domain {
  "Unique identifier"
  id: string

  "Workspace belongs to"
  workspace: Workspace

  "Domain name"
  name: string

  "Status of domain approval process"
  status: DomainStatus

  "Last verification of DNS"
  lastCheckedAt: any

  "When workspace was created"
  createdAt: any

  "Last update of the workspace"
  updatedAt: any
}

export interface DomainVerificationInstruction {
  /**
   * Verification type
   * @example "CNAME"
   * @example "TXT"
   */
  type: string
  /**
   * Verification name
   * @example "test.example.com"
   */
  name: string
  /**
   * Verification value
   */
  value: string
  /**
   * Verification reason
   */
  reason: string
}

export interface DomainInstructions {
  /**
   * Workspace domain
   */
  domain: Domain
  /**
   * Workspace result code
   */
  resultCode: number
  /**
   * Workspace instruction message
   */
  instructions: DomainVerificationInstruction[]
}

export interface Workspace {
  "Unique identifier"
  id: string

  "Name"
  name: string

  "Brand Name for white label"
  brandName: string

  "Small squared logo for white label"
  brandLogoSmall: string

  "Main description, if given"
  description: String

  "When workspace was created"
  createdAt: any

  "Last update of the workspace"
  updatedAt: any

  "Domain for white label"
  domain: Domain

  /**
   * User
   */
  user: {
    __typename: 'User'
    id: string
    bio: string | null
    vanity_name: string | null
  }

  "Hide support UI for consumer"
  hideSupportUIForConsumer: boolean
}

export interface AuthorizationGroup {
  /**
   * Unique identifier
   */
  id: string
  value: number
  object: Element
  group: Group
  /**
   * When authorization group was created
   */
  createdAt: string
  /**
   * Last update of the authorization group
   */
  updatedAt: string
}

export interface Group {
  /**
   * Unique identifier
   */
  id: string
  /**
   * Custom identifier
   */
  identifier: string
  /**
   * Workspace result code
   */
  name: string
  /**
   * Main description, if given
   */
  description: String
  /**
   * Total users in the group
   */
  usersCount: number
  /**
   * Workspace of the group
   */
  workspace: Workspace
  /**
   * Authorizations of the group
   */
  authorizations: [AuthorizationGroup]
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CollectionDisplayStatus {
  analytics = 'analytics',
  default = 'default',
}

export enum CollectionSellingMethodType {
  contact = 'contact',
  online = 'online',
}

export enum CollectionType {
  mixed = 'mixed',
  video = 'video',
  blended = 'blended',
}

export enum ContentDisplayStatus {
  analytics = 'analytics',
  default = 'default',
}

export enum ContentType {
  audio = 'audio',
  event = 'event',
  image = 'image',
  link = 'link',
  pdf = 'pdf',
  quiz = 'quiz',
  text = 'text',
  video = 'video',
}

export enum EventContentStatus {
  expired = 'expired',
  in_progress = 'in_progress',
  past = 'past',
  scheduled = 'scheduled',
}

export enum EventContentSubtype {
  online_event = 'online_event',
  presence_event = 'presence_event',
  zoom_event = 'zoom_event',
}

export enum QuizContentQuestionType {
  essay = 'essay',
  matching = 'matching',
  missing_word = 'missing_word',
  multiple_choice = 'multiple_choice',
  numerical = 'numerical',
  single_choice = 'single_choice',
  true_false = 'true_false',
}

export const QUICK_QUIZ_MAX_QUESTION_LENGTH = 200
export const SELF_ASSESSMENT_TEST_MAX_QUESTION_LENGTH = 500
export const VERIFICATION_TEST_MAX_QUESTION_LENGTH = 500
export const QUICK_QUIZ_MAX_ANSWER_LENGTH = 100
export const SELF_ASSESSMENT_TEST_MAX_ANSWER_LENGTH = 500
export const VERIFICATION_TEST_MAX_ANSWER_LENGTH = 500

export enum QuizContentSubtype {
  quick_quiz = 'quick_quiz',
  self_assessment_test = 'self_assessment_test',
  verification_test = 'verification_test',
}

export enum RemoveUserElementType {
  collection = 'collection',
  content = 'content',
  folder = 'folder',
}

export enum UserExternalAccountProvider {
  apple = 'apple',
  facebook = 'facebook',
  google = 'google',
  instagram = 'instagram',
  linkedin = 'linkedin',
  microsoft = 'microsoft',
  twitter = 'twitter',
  zoom = 'zoom',
}

export enum Visibility {
  mine = 'mine',
  private = 'private',
  public = 'public',

  protected = 'protected',
  preview = 'preview',
}

export enum UserCategory {
  marketing_communication = 'marketing_communication',
  consulting_strategy = 'consulting_strategy',
  training_academy = 'training_academy',
  tech_data = 'tech_data',
}

export interface CreateCollectionInput {
  cover?: any | null
  description?: string | null
  label?: string | null
  presentation?: string | null
  tags?: string[] | null
  title: string
  type?: CollectionType | null
  visibility?: Visibility | null
  selling?: boolean | null
  sellingPricing?: number | null
  sellingCurrency?: string | null
  sellingMethod?: CollectionSellingMethodType | null
  privacyPolicy?: string | null
}

export interface CreateContentInput {
  cover?: any | null
  description?: string | null
  label?: string | null
  tags?: string[] | null
  title?: string | null
  type?: ContentType | null
  url: any
  visibility?: Visibility | null
}

export interface CreateEventContentInput {
  cover?: any | null
  description?: string | null
  end?: any | null
  label?: string | null
  location?: string | null
  participants?: number | null
  presentation?: string | null
  registration?: boolean | null
  start?: any | null
  subtype: EventContentSubtype
  tags?: string[] | null
  title: string
  url?: any | null
  visibility?: Visibility | null
}

export interface CreateImageContentInput {
  description?: string | null
  label?: string | null
  subtype?: string | null
  tags?: string[] | null
  title?: string | null
  type?: ContentType | null
  urls: any[]
  visibility?: Visibility | null
}

export interface CreateQuizContentInput {
  appendRequiredQuestions?: boolean | null
  basket?: number | null
  canRepeat?: boolean | null
  canRepeatOnlyFailure?: boolean | null
  canRepeatMaximum?: number | null
  cover?: any | null
  description?: string | null
  instructions?: string | null
  label?: string | null
  questions: any
  questionsNavigation?: boolean | null
  quizFeedbackSuccessMessage?: string | null
  quizFeedbackSuccessImage?: any | null
  quizFeedbackFailureMessage?: string | null
  quizFeedbackFailureImage?: any | null
  timeLimit?: number | null
  randomOrder?: boolean | null
  restartFromBegin?: boolean | null
  separateEvaluation?: boolean | null
  showAnswer?: boolean | null
  showProgress?: boolean | null
  showSummary?: boolean | null
  subtype?: QuizContentSubtype | null
  successPoints?: number | null
  tags?: string[] | null
  title: string
  visibility?: Visibility | null
}

export interface CreateTextContentInput {
  body: string
  cover?: any | null
  description?: string | null
  label?: string | null
  tags?: string[] | null
  title: string
  visibility?: Visibility | null
}

export interface SellingContactRequestInput {
  collectionId: string
  email: string
  message: string
  name: string
}

export interface UpdateCollectionInput {
  cover?: any | null
  description?: string | null
  label?: string | null
  presentation?: string | null
  tags?: string[] | null
  title?: string | null
  visibility?: Visibility | null
  selling?: boolean | null
  sellingPricing?: number | null
  sellingCurrency?: string | null
  sellingMethod?: CollectionSellingMethodType | null
  privacyPolicy?: string | null
}

export interface UpdateContentInput {
  cover?: any | null
  description?: string | null
  label?: string | null
  tags?: string[] | null
  title?: string | null
  url?: any | null
  visibility?: Visibility | null
}

export interface UpdateEventContentInput {
  cover?: any | null
  description?: string | null
  end?: any | null
  label?: string | null
  location?: string | null
  participants?: number | null
  presentation?: string | null
  registration?: boolean | null
  start?: any | null
  tags?: string[] | null
  title?: string | null
  url?: any | null
  visibility?: Visibility | null
}

export interface UpdateImageContentInput {
  description?: string | null
  label?: string | null
  tags?: string[] | null
  title?: string | null
  urls: any[]
  visibility?: Visibility | null
}

export interface UpdateQuizContentInput {
  appendRequiredQuestions?: boolean | null
  basket?: number | null
  canRepeat?: boolean | null
  canRepeatOnlyFailure?: boolean | null
  canRepeatMaximum?: number | null
  cover?: any | null
  description?: string | null
  instructions?: string | null
  label?: string | null
  questions?: any | null
  questionsNavigation?: boolean | null
  quizFeedbackSuccessMessage?: string | null
  quizFeedbackSuccessImage?: any | null
  quizFeedbackFailureMessage?: string | null
  quizFeedbackFailureImage?: any | null
  timeLimit?: number | null
  randomOrder?: boolean | null
  restartFromBegin?: boolean | null
  separateEvaluation?: boolean | null
  showAnswer?: boolean | null
  showProgress?: boolean | null
  showSummary?: boolean | null
  subtype?: QuizContentSubtype | null
  successPoints?: number | null
  tags?: string[] | null
  title?: string | null
  visibility?: Visibility | null
}

export interface UpdateTextContentInput {
  body: string
  cover?: any | null
  description?: string | null
  label?: string | null
  tags?: string[] | null
  title?: string | null
  visibility?: Visibility | null
}

export interface UpdateUserInput {
  bio?: string | null
  firstname?: string | null
  lastname?: string | null
  website?: any | null
  picture?: any | null
  category?: UserCategory | null
  location?: string | null
}

export interface UpdateWorkspaceInput {
    id: string
    name: string
    brandName: string
    brandLogoSmall: string
    description: string
    hideSupportUIForConsumer: boolean
}

//==============================================================
// END Enums and Input Objects
//==============================================================
